// Mock data for the dashboard

// Recent invoices data
export const recentInvoices = [
  { id: 'INV-2023-001', patient: 'John Smith', amount: 1250.0, status: 'paid', date: '2023-05-15' },
  { id: 'INV-2023-002', patient: 'Sarah Johnson', amount: 850.5, status: 'pending', date: '2023-05-14' },
  { id: 'INV-2023-003', patient: 'Michael Brown', amount: 1750.75, status: 'overdue', date: '2023-05-10' },
  { id: 'INV-2023-004', patient: 'Emily Davis', amount: 550.25, status: 'paid', date: '2023-05-08' },
  { id: 'INV-2023-005', patient: 'Robert Wilson', amount: 1100.0, status: 'pending', date: '2023-05-07' }
]

// Upcoming payments data
export const upcomingPayments = [
  { id: 'PAY-2023-001', source: 'Medical Aid', amount: 3250.0, dueDate: '2023-05-20' },
  { id: 'PAY-2023-002', source: 'Patient Payment', amount: 850.5, dueDate: '2023-05-22' },
  { id: 'PAY-2023-003', source: 'Medical Aid', amount: 1750.75, dueDate: '2023-05-25' }
]

// Notifications data
export const notifications = [
  { id: 1, message: 'Medical aid claim #CL-2023-042 was approved', time: '2 hours ago', read: false },
  { id: 2, message: 'New patient registration completed', time: '5 hours ago', read: false },
  { id: 3, message: 'Invoice #INV-2023-003 is overdue', time: '1 day ago', read: true },
  { id: 4, message: 'Remittance advice received from Discovery Health', time: '2 days ago', read: true }
]

// Monthly revenue data for chart
export const monthlyRevenue = [
  { month: 'Jan', revenue: 42500 },
  { month: 'Feb', revenue: 38700 },
  { month: 'Mar', revenue: 51200 },
  { month: 'Apr', revenue: 47800 },
  { month: 'May', revenue: 55300 }
]

// Alert items
export const alertItems = [
  { title: 'Overdue Invoices', count: 3, icon: 'clock', color: '#f5222d' },
  { title: 'Claims Requiring Attention', count: 2, icon: 'file', color: '#faad14' },
  { title: 'Upcoming Remittances', count: 5, icon: 'calendar', color: '#1890ff' }
]

// Collection performance data
export const collectionPerformance = [
  { title: 'Medical Aid Claims', percent: 85 },
  { title: 'Patient Payments', percent: 72 },
  { title: 'Overall Collection', percent: 78 }
]
